module.exports = __FOREMAN_VENDOR__NOVNC_NOVNC_CORE_RFB__;